import styles from "./lakimi-assistant-header.css?raw";

const template = document.createElement("template");
template.innerHTML = `<style>${styles}</style>
<img style="display:none" src="./avatar.png" class="assistant-avatar">
<div class="assistant-name">Assistant</div>
`;

export class LakimiAssistantHeader extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    this.nameElement = this.shadowRoot.querySelector(".assistant-name");
    this.avatarElement = this.shadowRoot.querySelector(".assistant-avatar");
  }

  static get observedAttributes() {
    return ["avatar", "name"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "avatar") {
      if (newValue) {
        this.avatarElement.src = `data:image/png;base64,${newValue}`;
        this.avatarElement.style.display = "block";
      } else {
        this.avatarElement.style.display = "none";
      }
    } else if (name === "name") {
      this.nameElement.innerText = newValue;
    }
  }
}

customElements.define("lakimi-assistant-header", LakimiAssistantHeader);
